import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import { BeatLoader } from "react-spinners";

class CrispMerchantGstFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gstList: [],
            selectedGsts: [],
            isLoading: true,
            isListOpen: false,
            headerTitle: "Select [GST Number]",
            searchQuery: ""
        };
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        this.fetchGstNumbers(false, "");
        window.addEventListener("click", this.closeDropdown);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.closeDropdown);
    }

    fetchGstNumbers(isSearch = false, searchQuery = "") {
        if(isSearch===false){
            this.setState({
                selectedGsts:[]
           })
        }
        this.setState({ isLoading: true });
        axios
            .post(config.get("API_URL") + "/filters/get-crisp-merchant-gst-numbers", {
                search_query: searchQuery,
                selected_values: this.state.selectedGsts.map(item => item.value)
            }, {
                headers: { Authorization: ` ${localStorage.usertoken}` }
            })
            .then((response) => {
                let gstNumbers = response.data.map((item) => ({
                    value: item.gst_no || "NA",
                    label: item.gst_no || "NA",
                }));
                const selected = (this.props.value || []).map(val => ({
                    value: val,
                    label: val
                }));
                this.setState({
                    gstList: gstNumbers,
                    isLoading: false,
                    selectedGsts:selected
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ isLoading: false });
            });
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({ isListOpen: !prevState.isListOpen }));
    };

    closeDropdown(e) {
        if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
            this.setState({ isListOpen: false });
        }
    }

    handleSearch = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query });
        setTimeout(() => this.fetchGstNumbers(true, query), 300);
    };

    handleSelect(item, checked) {
        let selected = [...this.state.selectedGsts];
        if (checked) {
            selected.push(item);
        } else {
            selected = selected.filter((i) => i.value !== item.value);
        }
        this.setState({ selectedGsts: selected });
        this.props.onSelectCrispMerchantGstNo(
            selected,
            selected.map((s) => s.value)
        );
    }
    removeCrispMerchantGst = () => {
        const val = '';
        this.props.onSelectCrispMerchantGst(val);
        this.setState({
            selectedGsts: [],
            gstList: [],
            searchQuery: ""
        });
    };

    render() {
        const { gstList, selectedGsts, isListOpen, isLoading } = this.state;
        return (
            <div className="dd-wrapper" ref={(ref) => (this.dropdownRef = ref)}>
                <div className="dd-header" onClick={this.toggleDropdown}>
                    {selectedGsts.length === 0 ? (
                        <div className="dd-header-title">Select [GST Number]</div>
                    ) : (
                        <div className="dd-header-title">{selectedGsts.length} Selected</div>
                    )}
                    <i className="fa fa-angle-down"></i>
                </div>

                {isListOpen && (
                    <div role="list" onClick={(e) => e.stopPropagation()}>
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            value={this.state.searchQuery}
                            onChange={this.handleSearch}
                        />
                        <ul className="dd-list">
                            {isLoading ? (
                                <li>
                                    <BeatLoader size={5} color="#666" loading={true} />
                                </li>
                            ) : (
                                gstList.map((item, index) => {
                                    const checked = selectedGsts.some((s) => s.value === item.value);
                                    return (
                                        <li
                                            key={index}
                                            className={`dd-list-item ${checked ? "dd-list-active" : ""}`}
                                            onClick={() => this.handleSelect(item, !checked)}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                readOnly
                                            />
                                            &nbsp;&nbsp;{item.label}
                                        </li>
                                    );
                                })
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default CrispMerchantGstFilter;
